document.addEventListener('DOMContentLoaded', function () {
    const heroSwiper = new Swiper('.hero-slider-swiper', {
        loop: false,
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination-hero',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1
            }
        }
      });
});